import CookiesSettings from './CookiesSettings.vue'

export default CookiesSettings
